import { useNavigate } from "react-router-dom";
import ErrorImage from "../assets/error/Page-not-found.svg";
import Ellipse1 from "../assets/error/Ellipse 24.svg";
import Ellipse2 from "../assets/error/Ellipse 22.svg";
import Ellipse3 from "../assets/error/Ellipse 21.svg";
import Ellipse4 from "../assets/error/Ellipse 23.svg";

function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="h-screen w-full bg-[#D8DEEF] font-alexandria flex items-center justify-center p-4">
      <img
        src={Ellipse1}
        alt="Ellipse 1"
        className="absolute bottom-0 left-0 w-[200px] sm:w-[250px] md:w-[380px] z-10"
      />
      <img
        src={Ellipse4}
        alt="Ellipse 4"
        className="absolute bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[400px] z-10 opacity-[60%]"
      />
      <img
        src={Ellipse2}
        alt="Ellipse 2"
        className="absolute bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[250px] z-10"
      />
      <img
        src={Ellipse3}
        alt="Ellipse 2"
        className="absolute  bottom-0 left-0 w-[150px] sm:w-[200px] md:w-[250px] opacity-[60%] z-10"
      />

      <div className="bg-white rounded-[20px]  border border-[#E5E5E5] w-[950px] h-auto md:h-[670px] flex flex-col md:flex-row items-center justify-between p-10 sm:p-16 md:px-[125px] md:py-[140px] relative z-10">
        <div className="text-left space-y-[40px] md:space-y-[70px]">
          <div className="max-w-[302px] text-transparent bg-clip-text bg-gradient-to-b from-[#4772F1] to-[#873FE2]">
            <h1 className="text-[36px] sm:text-[40px] md:text-[50px] font-medium  leading-[125%]">
              Oops!
            </h1>
            <div className="flex flex-col items-start gap-2">
              <h2 className="text-[36px] sm:text-[40px] md:text-[50px] font-medium leading-[125%]">
                Page Not
              </h2>
              <h3 className="text-[36px] sm:text-[40px] md:text-[50px] font-medium leading-[125%]">
                Found (404)
              </h3>
            </div>
          </div>
          <p className="text-[#4772F1] text-[16px] sm:text-[18px] md:text-[20px] font-normal max-w-[242px] leading-[125%]">
            The page you’re looking for doesn’t exist
          </p>
          <button
            onClick={handleGoHome}
            className="mt-[30px] h-[48px] sm:h-[55px] text-[16px] sm:text-[18px] font-semibold px-6 py-2 bg-[#4772F1] w-full sm:w-[290px] md:w-[315px] border-[2px] border-[#4772F1] text-white rounded-[8px] hover:bg-[#3a2ecc] transition"
          >
            Go to Homepage
          </button>
        </div>

        <img
          src={ErrorImage}
          alt="404 illustration"
          className="w-full sm:w-[303px] sm:h-[303px] mt-10 md:mt-0"
        />
      </div>
    </div>
  );
}

export default NotFoundPage;
